define('modules/editor/models/elements/video',['require','exports','module','./base','modules/editor/services/video_content/index'],function(require, exports, module){
  "use strict";
  var BaseElement = require("./base"),
      VideoContentService = require("modules/editor/services/video_content/index");

  module.exports = BaseElement.extend({
    name: "element:video",
    defaultNameKey:"video",
    propertyGroups: [
      {
        name: "video:content",
        defaults: {
          content: ""
        }
      },
      {
        name: "idclass",
        defaults: {
          "id": "",
          "className": ""
        }
      }
    ],
    hasContent: function(){
      var pg = this.getPropertyGroup("video:content");
      return pg && pg.get && pg.get("content") !== "";
    },
    getContent: function(){
      var pg = this.getPropertyGroup("video:content");
      if(pg && pg.get){
        return pg.get("content");
      }
      else {
        return "";
      }
    },
    editVideoContent: function(){
      VideoContentService.editVideo(this.getContent(), _.bind(this.saveData, this));
    },
    saveData: function(content){
      this.getPropertyGroup("video:content").set("content", content);
      this.parseContent(content);
    },
    parseContent: function(htmlContent){
      var $element = $(htmlContent),
          height = $element.attr("height"),
          width = $element.attr("width");

      if(height && width){
        this.setSize({
          width: parseInt(width),
          height: parseInt(height)
        });
      }
    }
  });
});

